import React, { useRef, useState } from 'react';
import dayjs from 'dayjs';

import TextField from '@material-ui/core/TextField'

const checkDate = text => {
    // enforce DD/MM/YYYY input
    const elements = text.split(/[/-]/);

    if (elements.length !== 3) return false;

    var [day, month, year] = elements;

    if (day.length === 1) day = "0" + day;
    if (month.length === 1) month = "0" + month;

    if (
        /^[0-3][0-9]?$/.test(day) &&
        /^[0-1][0-9]?$/.test(month) &&
            (year.length === 4 && /^20[2-3][0-9]?$/.test(year))
    ) {
        // dayjs can't parse dd/mm/yyyy without a plugin so 
        return `${year}-${month}-${day}`;
    }
    else {
        return false;
    }
}

const SafariDateInput = ({ value, hint, required, onChange }) => {
    const dateRef = useRef();
    const [highlight, setHighlight] = useState(required && !value);

    const handleChange = () => {

        const date = checkDate(dateRef.current.value);
        setHighlight(required && !date);
        
        if (date) {
            onChange(dayjs(date).format('YYYY-MM-DD'));
        }
        
    }
    
    // Safari still has no support for input type date on desktop !
    const initialDate = value ? dayjs(value).format('DD/MM/YYYY') : value;

    return (
        <TextField
            inputRef={dateRef}
            defaultValue={initialDate}
            placeholder="dd/mm/yyyy"
            onChange={handleChange}
            type="date"
            helperText={hint}
            InputLabelProps={{
                shrink: true,
            }}
            error={highlight}
        />
    );
}

export default SafariDateInput;